/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/430-steam2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4.749 13.063a1.313 1.313 0 00.729-2.405L4.446 9.97a2.105 2.105 0 11-1.548 2.124l1.124.749c.224.149.477.221.727.221zM13.333 0C14.8 0 16 1.2 16 2.667v10.666C16 14.801 14.8 16 13.333 16H2.667A2.674 2.674 0 010 13.333v-3.172l1.896 1.264a3.157 3.157 0 106.213.024l3.892-3.484a3.5 3.5 0 10-3.964-3.964L4.839 8.848a3.14 3.14 0 00-1.433.428L.002 7.007V2.668c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0zm-4 0a1.5 1.5 0 113.001.001A1.5 1.5 0 0110 4.5z"/>'
  }
})
